import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const SquaredBox = styled(Typography)`
  border-radius: 7px;
  padding: 10px;
  box-shadow: inset 0 0 0 1px rgb(0 0 0 / 10%);
`;

export default SquaredBox;
